<template>
  <div>
    <canvas style="width: 100%" id="circle" class="circle-item" width="720px" height="720px"></canvas>
  </div>
</template>

<script>
import { baseURL } from '../../utils/http'
import { MIFI_DEVICE_INFO, MIFI_PRODUCT_RCHARGE, MIFI_PRODUCT_RCHARGE_BUY } from '@/apis/cabinet'
import { mapState } from "vuex";
import wxpay from "weixin-jsapi"
export default {
  components: {
  },
  computed: {
  },
  watch: {

  },
  data () {
    return {
      width: 200,
      height: 200,
      progress: 0.5,
      canvas: null,
      circleX: null,
      circleY: null,
      lineWidth: 50,
      radius: 320,
      percent: null,
      ctx: null
    }
  },
  methods: {
    loadCircleProgress(data) {
      this.toCanvas(data)
    },
    toCanvas(progress) {
      var canvas = document.getElementById("circle")
      this.ctx = canvas.getContext("2d")
      this.percent = progress
      this.circleX = canvas.width / 2
      this.circleY = canvas.height / 2
      this.radius = 320
      this.lineWidth = 50
      this.circle(this.circleX, this.circleY, this.radius)
      this.sector(this.circleX, this.circleY, this.radius, (Math.PI * 2) / 3, this.percent)
    },
    circle(cx, cy, r) {
      this.ctx.beginPath()
      this.ctx.lineWidth = this.lineWidth
      this.ctx.strokeStyle = "rgba(255,255,255,0.2)"
      this.ctx.arc(cx, cy, r, Math.PI, 0)
      this.ctx.lineCap = "round"
      this.ctx.stroke()
    },
    sector(cx, cy, r, startAngle, endAngle) {
      this.ctx.beginPath()
      this.ctx.lineWidth = this.lineWidth
      var linGrad = this.ctx.createLinearGradient(
        this.circleX - this.radius - this.lineWidth,
        this.circleY,
        this.circleX + this.radius + this.lineWidth,
        this.circleY
      );
      linGrad.addColorStop(0.0, "#b7e68a")
      linGrad.addColorStop(1.0, "#15f30d")
      this.ctx.strokeStyle = linGrad
      this.ctx.lineCap = "round"
      this.ctx.arc(
        cx,
        cy,
        r,
        Math.PI,
        Math.PI + (endAngle / 100) * Math.PI,
        false
      );
      this.ctx.stroke()
    }
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
.circle-progress {
  width: 3.6rem;
  height: 2rem;
  margin: 0 auto;
  position: relative;
  z-index: 9999;
  display: flex;
  justify-content: center;

  .circle-item {
    width: 3.6rem;
    height: 3.6rem;
  }
}
</style>
